import React, { FC } from "react";
import { ErrorContainer } from "../../containers/error/error-container";
export const ErrorPage: FC<{ fromRoute?: boolean }> = ({ fromRoute }) => (
  <ErrorContainer fromRoute={fromRoute} />
);
